@if (event) {
  <div
    class="event-view-container"
    [ngClass]="viewMode === 'scheduler' ? 'class-for-scheduler' : ''"
  >
    <!-- <div class="color-indicator" *ngIf="!['PRIVATEEVENT', 'HOLIDAYEVENT', 'SICKEVENT', 'ILLNESSREPRESENTATIONEVENT', 'MATERNITYPROTECTION', 'NOEVENTS'].includes(event.original.type)" [ngStyle]="{ 'background-color': colorService.getStammteamColor(event.original) }"> -->
    @if (
      ![
        "PRIVATEEVENT",
        "HOLIDAYEVENT",
        "SICKEVENT",
        "ILLNESSREPRESENTATIONEVENT",
        "MATERNITYPROTECTION",
        "NOEVENTS",
      ].includes(event.original.type)
    ) {
      <div
        class="color-indicator"
        [ngStyle]="{
          'background-color': colorService.getStammteamColor(event.original),
        }"
      >
        <div class="icons">
          @if (
            !this.eventMarker && event && getStundenRelevanz(event.original)
          ) {
            <div class="icon-container">
              <img
                src="https://assets.tridimo.de/fontawesome/svgs/regular/circle-quarter-stroke.svg"
                alt="Stundenrelevant"
                class="info-icon"
                title="Stundenrelevant"
              />
            </div>
          }
          @if (event.original.online) {
            <div
              class="icon-container"
              [ngStyle]="{
                'background-color': iconService.getIconBackground(
                  event,
                  'online'
                ),
              }"
            >
              <img
                src="https://assets.tridimo.de/fontawesome/svgs/regular/wifi.svg"
                alt="Onlinetermin"
                title="Onlinetermin"
                class="info-icon"
              />
            </div>
          }
          @if (
            event.original.vorbereitungsmaterial === "1" ||
            event.original.vorbereitungsmaterial === true
          ) {
            <div
              class="icon-container"
              [ngStyle]="{
                'background-color': iconService.getPrepIconBackground(event),
              }"
            >
              <img
                src="https://assets.tridimo.de/fontawesome/svgs/regular/folder-open.svg"
                alt="Vorbereitungsmaterial"
                class="info-icon"
                title="Vorbereitungsmaterial"
              />
            </div>
          }
          @if (this.missing) {
            <div
              class="icon-container"
              [ngStyle]="{
                'background-color': iconService.getIconBackground(
                  event,
                  'interpretor'
                ),
              }"
            >
              <img
                src="https://assets.tridimo.de/fontawesome/svgs/regular/user.svg"
                alt="Fehlender Dolmetscher"
                class="int-icon"
                title="Fehlender Dolmetscher"
              />
            </div>
          }
          @if (this.overload && event.original.type === "MISSIONEVENT") {
            <div
              class="icon-container"
              [ngStyle]="{
                'background-color': iconService.getIconBackground(
                  event,
                  'overload'
                ),
              }"
            >
              <img
                src="https://assets.tridimo.de/fontawesome/svgs/regular/user-plus.svg"
                alt="Zuviele Dolmetscher"
                class="int-icon"
                title="Zuviele Dolmetscher"
              />
            </div>
          }
          @if (
            !event.original.online &&
            [
              "MISSIONEVENT",
              "TEAMEVENT",
              "MEETINGEVENT",
              "NOTBILLABLEEVENT",
            ].includes(event.original.type)
          ) {
            <div
              class="icon-container"
              [ngStyle]="{
                'background-color': iconService.getIconBackground(
                  event,
                  'location'
                ),
              }"
            >
              <img
                src="https://assets.tridimo.de/fontawesome/svgs/regular/map-location-dot.svg"
                alt="Adresse"
                class="info-icon"
                title="Adresse"
              />
            </div>
          }
        </div>
      </div>
    }
    <div
      class="event-content-container"
      [ngStyle]="colorService.getBackground(event.original)"
    >
      <div class="top-right-icon-container">
        <!-- Skill Warner -->
        @if (event.original.skillWarn) {
          <div class="warn-icon">
            <div
              class="icon"
              [style.color]="'white'"
              [innerHTML]="svgIconService.svgCache['warn']"
              title="Team oder Skill beachten!"
            ></div>
          </div>
        }
        <!-- Kategorie -->
        @if (iconService.getCategoryIcon(event.original.category)) {
          <div class="category-icon">
            <img
              [src]="iconService.getCategoryIcon(event.original.category)"
              alt="{{ event.original.category }}"
              title="{{ event.original.category }}"
            />
          </div>
        }
        <!-- Fremd Dolmetscher Badge -->
        @if (this.getMissingFremdDolmetscher(event)) {
          <div
            class="missing-int-badge"
            [title]="
              'Fehlende Fremd Dolmetscher: ' +
              this.getMissingFremdDolmetscher(event)
            "
          >
            <span>{{ this.getMissingFremdDolmetscher(event) }}</span>
          </div>
        }
      </div>
      <!-- Typ -->
      @if (iconService.getTypeIcon(event.original.type)) {
        <div
          class="type-icon"
          [ngClass]="event.original.ueberprueft ? 'greenBg' : ''"
        >
          <img
            [src]="iconService.getTypeIcon(event.original.type)"
            alt="{{ event.original.type }}"
            title="{{ event.original.type }}"
          />
        </div>
      }
      <!-- 1. Reihe -->
      <div>
        @if (
          ![
            "PRIVATEEVENT",
            "HOLIDAYEVENT",
            "SICKEVENT",
            "ILLNESSREPRESENTATIONEVENT",
            "MATERNITYPROTECTION",
            "NOEVENTS",
          ].includes(event.original.type)
        ) {
          <span class="event-title">{{ event.title }}</span>
        }
        @if (event.original.type === "MISSIONEVENT") {
          <span class="event-title"> {{ getCustomerNames(event) }}</span>
        }
        <!-- <span *ngIf="!['PRIVATEEVENT', 'HOLIDAYEVENT', 'SICKEVENT', 'ILLNESSREPRESENTATIONEVENT'].includes(event.original.type)" class="event-title">{{ getEventTitle(event) }}</span> -->
      </div>
      @if (
        [
          "HOLIDAYEVENT",
          "SICKEVENT",
          "ILLNESSREPRESENTATIONEVENT",
          "MATERNITYPROTECTION",
          "NOEVENTS",
        ].includes(event.original.type)
      ) {
        <div class="title-container" class="large-title-container">
          <span class="event-title-large">{{ event.title }}</span>
        </div>
      }
      @if (["PRIVATEEVENT"].includes(event.original.type)) {
        <div class="title-container" class="private-large-title-container">
          <span class="event-title-large">{{ event.title }}</span>
        </div>
      }
      <!-- <div *ngIf="!this.eventMarker && event.original.ticketno" > -->
      <!-- <div *ngIf="event.original.ticketno">{{ event.original.ticketno}} - </div> -->
      <!-- </div> -->
      <!-- 2. Reihe -->
      <div class="location">
        @if (!event.original.online) {
          <div>
            @if (event.original.location) {
              <div class="icon-container3">
                <img
                  src="https://assets.tridimo.de/fontawesome/svgs/regular/map-location-dot.svg"
                  alt=""
                />
                {{
                  event.original.location === "Lina-Bommer-Weg 6, 51149 Köln"
                    ? "Büro"
                    : event.original.location
                }}
              </div>
            }
          </div>
        }
        @if (event.original.online) {
          <div class="icon-container3">
            <!-- <img src="https://assets.tridimo.de/fontawesome/svgs/regular/timer.svg" alt="" *ngIf="!this.eventMarker && event.original.minuteBased" title="Minutengenau"> -->
            <!-- <span *ngIf="!this.eventMarker && event.original.minuteBased && event.original.onlineLink?.length">-</span> -->
            @if (!this.eventMarker && event.original.dialinTime) {
              <div class="icon-container">
                <img
                  src="https://assets.tridimo.de/fontawesome/svgs/regular/timer.svg"
                  alt="Einwahlzeit"
                  class="info-icon"
                  title="Einwahlzeit"
                />
              </div>
            }
            @for (
              item of event.original.onlineLink || [];
              track item;
              let i = $index
            ) {
              <div class="icon-container3">
                @if (i > 0) {
                  <span class="plus-separator">+</span>
                }
                @if (
                  item.platform !== "online" &&
                  item.platform !== "Link" &&
                  item.platform !== "Keine Plattform" &&
                  item.platform !== "studio"
                ) {
                  <img
                    [src]="platformIcons[item.platform]"
                    alt="{{ item.platform }}"
                    title="{{ item.platform }}"
                    class="platform-icon"
                  />
                }
                @if (item.platform === "online") {
                  <span>Online</span>
                }
                @if (item.platform === "studio") {
                  <span>Studio</span>
                }
              </div>
            }
          </div>
        }
      </div>
      <!-- 3. Reihe -->
      <div class="id-info-container">
        @if (event.original.informations) {
          <div class="informations-container">
            @for (icon of event.original.informations; track icon) {
              @if (icon.icon_name !== "fremd Dolmetscher") {
                <div class="information-icon">
                  @if (icon.icon_name !== "globe") {
                    <img
                      [src]="iconService.getIconUrl(icon.icon_name)"
                      [title]="
                        icon.type === 'checkbox' && icon.info
                          ? icon.title + ': ' + icon.info
                          : icon.type === 'select' && icon.value
                            ? icon.title + ': ' + icon.value
                            : icon.type === 'radio' && icon.value
                              ? icon.title
                              : icon.title
                      "
                    />
                  }
                  @if (icon.icon_name === "globe") {
                    <span
                      class="language-level-span"
                      [title]="
                        icon.type === 'checkbox' && icon.info
                          ? icon.title + ': ' + icon.info
                          : icon.type === 'select' && icon.value
                            ? icon.title + ': ' + icon.value
                            : icon.type === 'radio' && icon.value
                              ? icon.title
                              : ''
                      "
                    >
                      {{ getSprachlevel(icon) }}
                    </span>
                  }
                </div>
              }
            }
          </div>
        }
        @if (!this.eventMarker && (coData || fremdData)) {
          <div class="row-4">
            <div class="cr-container">
              @for (co of coData || []; track co) {
                @if (
                  ![
                    "PRIVATEEVENT",
                    "HOLIDAYEVENT",
                    "SICKEVENT",
                    "ILLNESSREPRESENTATIONEVENT",
                    "MATERNITYPROTECTION",
                    "NOEVENTS",
                  ].includes(event.original.type) &&
                  ![
                    "Allgemein",
                    "Intern",
                    "Abrechnung",
                    "Fremddolmetscher",
                  ].includes(co.workingType)
                ) {
                  <div
                    class="mini-user-icon"
                    [ngClass]="
                      co.workingType === 'Praktikant'
                        ? 'trainee-mini-icon-color'
                        : ''
                    "
                  >
                    @if (co.workingType !== "Praktikant") {
                      <span>{{ co.cr }}</span>
                    }
                    @if (co.workingType === "Praktikant") {
                      <span>P</span>
                    }
                  </div>
                }
              }
              @if (fremdData) {
                <div class="mini-fremd-icon">
                  <span>F</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
